import { render, staticRenderFns } from "./add-application.vue?vue&type=template&id=51a5dc4e&scoped=true&"
import script from "./add-application.vue?vue&type=script&lang=js&"
export * from "./add-application.vue?vue&type=script&lang=js&"
import style0 from "./add-application.vue?vue&type=style&index=0&id=51a5dc4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a5dc4e",
  null
  
)

export default component.exports